import { useEffect, useState } from "react";
import { IoCloudOfflineOutline, IoSyncOutline } from "react-icons/io5";
import { countQueued } from "@/offlineQueue";

/**
 * Fixed banner shown when offline or when there are pending mutations to sync.
 * Sits above the bottom nav.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const refresh = async () => {
      try { setPending(await countQueued()); } catch { setPending(0); }
    };
    refresh();
    const onOnline = () => { setOnline(true); refresh(); };
    const onOffline = () => setOnline(false);
    const onQueue = () => refresh();
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener("offline-queue-changed", onQueue);
    window.addEventListener("offline-queue-flushed", onQueue);
    const t = setInterval(refresh, 5000);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("offline-queue-changed", onQueue);
      window.removeEventListener("offline-queue-flushed", onQueue);
      clearInterval(t);
    };
  }, []);

  if (online && pending === 0) return null;

  const isOffline = !online;
  return (
    <div
      data-testid="offline-banner"
      role="status"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: "calc(72px + env(safe-area-inset-bottom))",
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
        zIndex: 90,
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          background: isOffline ? "rgba(226,0,26,0.95)" : "rgba(34,139,34,0.95)",
          color: "#fff",
          padding: "8px 14px",
          borderRadius: 999,
          fontSize: 13,
          fontWeight: 600,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        {isOffline ? <IoCloudOfflineOutline size={16} /> : <IoSyncOutline size={16} />}
        {isOffline
          ? (pending > 0
              ? `Offline — ${pending} in coda`
              : "Offline — le modifiche verranno sincronizzate")
          : `Sincronizzazione ${pending} modifiche…`}
      </div>
    </div>
  );
}
